import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TargetWithAudience } from '@core/models/target.model';
import { BaseService } from '@core/services/base/base.service';
import { ErrorHandlerService, HttpError } from '@core/services/error-handler.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TargetService extends BaseService {
  constructor(private httpService: HttpClient, private errorHandlerService: ErrorHandlerService) {
    super();
  }

  public getList(filter): Observable<any[]> {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de récuperer la liste des cibles. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    let url = environment.contract_microservice_api_base_url + '/target?' + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService
        .get(url)
        .pipe(
          map(response => {
            // TODO: add model (comes from table cible)
            return response;
          })
        )
        .subscribe(
          (response: any) => observer.next(response),
          error => {
            this.errorHandlerService.showErrorMessage(httpErrors, error.status);
            observer.error(error);
          }
        );
    });
  }

  public getTargetsWithAvgAudience(idTvChannel: number) {
    const httpErrors: HttpError[] = [
      {
        statusCode: 404,
        message: 'Impossible de récuperer la liste des cibles present dans le fichier restit. Veuillez essayer plus tard.',
      },
      {
        statusCode: 500,
        message: 'Une erreur est survenue. Veuillez essayer plus tard.',
      },
    ];

    const filter = {
      idTvChannel: idTvChannel,
    };
    let url = environment.price_list_microservice_base_url + '/get-targets-with-avg-audience?' + this.getParamsFromFilter(filter);

    return new Observable(observer => {
      this.httpService
        .get(url)
        .pipe(
          map(response => {
            if (response && response['data']) {
              return response['data'].map((targetItem: any) => {
                return new TargetWithAudience(targetItem);
              });
            }
            return [];
          })
        )
        .subscribe(
          (response: any) => observer.next(response),
          error => {
            this.errorHandlerService.showErrorMessage(httpErrors, error.status);
            observer.error(error);
          }
        );
    });
  }
}
